<template>
  <v-tabs>
    <v-tab><h2>瀏覽</h2></v-tab>
    <v-tab-item class="pa-1 pa-sm-4">
      <!-- Save & Reset Buttons -->
      <v-row>
        <v-col sm="12" md="9" class="pb-0 pt-0 text-end">
          <v-btn
            class="ma-2"
            elevation="4"
            color="success"
            @click="handleOnNewAddOne"
          >
            <v-icon>mdi-plus-thick</v-icon>
          </v-btn>
          <v-btn
            class="ma-2"
            elevation="4"
            color="error"
            @click="handleOnDeleteAddOne"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <!-- Table -->
      <v-row>
        <v-col sm="12" md="9" class="pb-0 pt-0">
          <v-data-table
            ref="group-form"
            :headers="headers"
            item-key="id"
            :items="!isSending ? listByOption2 : []"
            class="elevation-4 my-group-table"
            :search="tableSearch"
            :loading="isSending"
            loading-text="資料更新中..."
            no-data-text="暫無資料"
            no-results-text="沒有匹配的資料"
            show-select
            v-model="tableCBSelected"
            :mobile-breakpoint="tableModes[tableMode].breakpoint"
          >
            <template v-slot:item.tag="{ item }">
              {{ item.tag === 1 ? '代理群組' : '會員群組' }}
            </template>
            <template v-slot:top>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="tableSearch"
                    label="快速搜尋"
                    class="mx-4"
                  ></v-text-field>
                </v-col>
                <v-col v-if="level < 6">
                  <v-combobox
                    label="建立帳號"
                    :items="!isSending ? groupAgentOptions : []"
                    v-model="optionSelected3"
                    @change="handleOnOpChange3"
                  ></v-combobox>
                </v-col>
                <v-col v-if="level < 6">
                  <v-combobox
                    label="群組類型"
                    :items="options2"
                    v-model="optionSelected2"
                    :disabled="optionSelected3.value !== -1"
                  ></v-combobox>
                </v-col>
              </v-row>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon class="mr-2" @click="handleOnEditAddOne(item)">
                mdi-pencil
              </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-tab-item>
    <!-- Dialog -->
    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h3>{{ dialogMode ? '新增群組' : '編輯群組' }}</h3>
        </v-card-title>
        <!--  -->
        <v-card-text>
          <v-form
            ref="group-form"
            lazy-validation
            v-model="dialogInputValid"
            @submit.prevent=""
          >
            <v-text-field
              v-model="name"
              label="群組名稱"
              :rules="dialogInputRules"
              :counter="10"
              required
            ></v-text-field>
            <v-combobox
              v-if="tag === 1"
              label="群組類型"
              v-model="optionSelected1"
              :items="options1"
              :rules="dialogComboBoxRules"
              required
            ></v-combobox>
            <v-row>
              <v-col cols="6">
                <v-checkbox
                  v-model="checkbox1"
                  hide-details
                  class="shrink mr-2 mt-0"
                  @change="handleOnCKBChange1"
                ></v-checkbox>
                <v-text-field
                  v-model="premium"
                  label="群組溢價"
                  :rules="dialogNumberRules"
                  :disabled="!checkbox1"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-checkbox
                  v-model="checkbox2"
                  hide-details
                  class="shrink mr-2 mt-0"
                  @change="handleOnCKBChange2"
                ></v-checkbox>
                <v-text-field
                  v-model="premium_p"
                  label="群組溢價(%)"
                  :rules="dialogNumberRules"
                  :disabled="!checkbox2"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-switch
              v-model="enb"
              inset
              color="primary"
              :label="`狀態:${enb ? '啟用' : '關閉'}`"
            ></v-switch>
          </v-form>
        </v-card-text>
        <!--  -->
        <v-card-actions>
          <v-row>
            <v-col>
              <v-btn elevation="4" color="error" @click="dialog = false">
                <v-icon>mdi-close-thick</v-icon>
              </v-btn>
            </v-col>
            <v-col class="text-end">
              <v-btn
                elevation="4"
                color="success"
                @click="handleOnDialogSave"
                :disabled="isSending"
              >
                <v-icon>mdi-check-bold</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
        <!--  -->
        <v-progress-linear
          :active="isSending"
          indeterminate
          absolute
          bottom
        ></v-progress-linear>
      </v-card>
    </v-dialog>
  </v-tabs>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { mapActions, mapState } from 'vuex'
export default {
  data: () => ({
    // Dialog
    dialog: false,
    dialogInputValid: false,
    dialogMode: true,
    dialogOnSaveFn: undefined,
    dialogInputRules: [
      v => !!v || '不可空白',
      v => v.length <= 20 || '字數不可超過20個字'
    ],
    dialogNumberRules: [
      v => Number(v) >= 0 || '必須是正整數',
      v => Number.isInteger(Number(v)) || '必須是整數',
      v => !!v || '不可空白'
    ],
    dialogComboBoxRules: [
      v => !!v || '不可空白',
      v => typeof v === 'object' || '請選擇現有群組'
    ],
    name: '',
    enb: true,
    premium: '',
    premium_p: '',
    checkbox1: true,
    checkbox2: false,
    // Combobox
    optionSelected1: '',
    options1: [],
    optionSelected2: '',
    options2: [],
    optionSelected3: '',
    // Table
    tableSearch: '',
    tableCBSelected: [],
    headers: [
      {
        text: '群組名稱',
        align: 'start',
        value: 'name'
      },
      {
        text: '群組類型',
        align: 'start',
        value: 'tag'
      },
      {
        text: '更新時間',
        align: 'start',
        value: 'update_itme'
      },
      {
        text: '',
        align: 'start',
        value: 'actions'
      }
    ]
    //
  }),
  computed: {
    ...mapState('account', ['tag', 'uid', 'ad_id', 'ag_id', 'user', 'level']),
    ...mapState('admin', [
      'tableModes',
      'tableMode',
      'isSending',
      'groups',
      'groupAgentOptions'
    ]),
    listByOption2() {
      const o = []
      if (!this.optionSelected2) return o
      if (this.optionSelected2.value === undefined) return o

      if (!this.optionSelected3 && this.level < 6) return o
      if (this.optionSelected3.value === undefined && this.level < 6) return o

      const tag = this.optionSelected2.value
      const ag_id = this.level < 6 ? this.optionSelected3.value : 0

      if (ag_id === -1 && this.level < 6) {
        // All Admin
        if (tag === 0) {
          this.groups.forEach(e => {
            if (e.ag_id === 0) o.push(e)
          })
        } else {
          this.groups.forEach(e => {
            if (e.ag_id === 0 && e.tag === tag) o.push(e)
          })
        }
      } else if (ag_id === 0) {
        // All Agent
        if (tag === 0) {
          this.groups.forEach(e => {
            if (e.ag_id > 0) o.push(e)
          })
        } else {
          this.groups.forEach(e => {
            if (e.ag_id > 0 && e.tag === tag) o.push(e)
          })
        }
      } else {
        this.groups.forEach(e => {
          if (e.ag_id === ag_id) o.push(e)
        })
      }
      // if (g_id === 0) return this.groups
      // this.groups.forEach(e => {
      //   if (e.g_id === g_id) o.push(e)
      // })
      return o
    }
  },
  methods: {
    ...mapActions('admin', [
      'getAllGroups',
      'addGroup',
      'updateGroup',
      'deleteGroup'
    ]),
    handleOnOpChange3() {
      if (this.optionSelected3.value !== -1) {
        this.optionSelected2 = this.options2[0]
      }
    },
    handleOnCKBChange1() {
      this.checkbox2 = !this.checkbox1
      this.premium_p = '0'
    },
    handleOnCKBChange2() {
      this.checkbox1 = !this.checkbox2
      this.premium = '0'
    },
    handleOnNewAddOne() {
      this.dialogMode = true
      this.name = ''
      this.optionSelected1 = this.options1[0]
      this.enb = 1
      this.premium = '0'
      this.premium_p = '0'

      this.checkbox1 = true
      this.handleOnCKBChange1()

      this.dialog = true

      this.$nextTick(() => {
        if (!this.dialogInputValid) this.$refs['group-form'].resetValidation()
      })

      this.dialogOnSaveFn = async () => {
        if (!this.$refs['group-form'].validate()) return
        const { ad_id, name, user, level, uid } = this
        await this.addGroup({
          premium: this.premium * 1,
          premium_p: this.premium_p * 1,
          ad_id,
          ag_id: this.ag_id || 0,
          name,
          tag: this.optionSelected1.value,
          enb: this.enb ? 1 : 0,
          user,
          level,
          uid
        })
        this.dialog = false
      }
    },
    handleOnEditAddOne(item) {
      this.name = item.name
      this.optionSelected1 = {
        text: item.tag === 1 ? '代理群組' : '會員群組',
        value: item.tag
      }
      this.enb = item.enb
      this.premium = item.premium + ''
      this.premium_p = item.premium_p + ''

      if (item.premium > 0 || item.premium_p < 1) {
        this.checkbox1 = true
        this.checkbox2 = false
      } else {
        this.checkbox1 = false
        this.checkbox2 = true
      }

      this.dialog = true
      this.dialogOnSaveFn = async () => {
        if (!this.$refs['group-form'].validate()) return
        const { user, level, uid } = this
        await this.updateGroup({
          premium: this.premium * 1,
          premium_p: this.premium_p * 1,
          id: item.id,
          name: this.name,
          enb: this.enb ? 1 : 0,
          tag: this.optionSelected1.value,
          user,
          level,
          uid
        })
        this.dialog = false
      }
    },
    handleOnDeleteAddOne() {
      if (this.tableCBSelected.length < 1) return
      if (!confirm('確定刪除嗎?')) return
      const ids = []
      this.tableCBSelected.forEach(e => {
        ids.push(e.id)
      })
      const { user, level, uid } = this
      this.deleteGroup({
        ids: JSON.stringify(ids),
        level,
        user,
        uid
      })
    },
    // Dialog
    handleOnDialogSave() {
      if (this.dialogOnSaveFn) this.dialogOnSaveFn()
    }
  },
  created() {
    this.$emit('setTopLabel', 4)

    if (this.level < 6) {
      // Admin
      this.options1 = [
        { text: '代理群組', value: 1 },
        { text: '會員群組', value: 2 }
      ]
      this.options2 = [
        { text: '所有群組', value: 0 },
        { text: '代理群組', value: 1 },
        { text: '會員群組', value: 2 }
      ]
      this.optionSelected1 = this.options1[0]
      this.optionSelected2 = this.options2[0]
    } else if (this.level > 5 && this.level < 10) {
      // Agent
      this.options1 = [{ text: '會員群組', value: 2 }]
      this.options2 = [
        { text: '所有群組', value: 0 },
        { text: '會員群組', value: 2 }
      ]
      this.optionSelected1 = this.options1[0]
      this.optionSelected2 = this.options2[0]
    }
    //
    ;(async () => {
      const { user, level, uid } = this
      await this.getAllGroups({ user, level, uid })
      this.groupAgentOptions.unshift({ text: '所有代理商', value: 0 })
      this.groupAgentOptions.unshift({ text: '管理員', value: -1 })
      this.optionSelected3 = this.groupAgentOptions[0]
    })()
  }
}
</script>

<style lang="scss">
.my-group-table {
  th,
  td {
    font-size: 18px;
  }
}

@media screen and (max-width: 600px) {
  .my-group-table {
    .col {
      padding-bottom: 0px !important;
    }
    .v-input {
      label,
      input {
        font-size: 20px;
      }
    }

    th {
      min-width: 100px;
    }

    th,
    td {
      padding-right: 2px !important;
      padding-left: 2px !important;
    }

    .v-data-footer {
      .v-data-footer__select {
        margin-right: 0px;
      }
    }
  }
}
</style>
